import React from "react";
import {
  Calculator,
  FileText,
  Building2,
  FileSignature,
  Stamp,
  HeartHandshake,
  ArrowUpRight,
  Check,
} from "lucide-react";

const SERVICES = [
  {
    icon: Calculator,
    title: "Preparación de Impuestos",
    tagline: "Personales y empresariales · IRS Certified",
    items: [
      "Declaraciones personales",
      "Declaraciones empresariales",
      "Enmiendas y correcciones",
      "Planificación tributaria",
      "Resolución de cartas del IRS",
      "Extensiones",
      "Trabajadores independientes",
      "LLC, Corporaciones y Partnerships",
    ],
  },
  {
    icon: FileText,
    title: "ITIN Number",
    tagline: "Certifying Acceptance Agent (CAA) autorizada",
    items: [
      "Solicitud de ITIN nuevo",
      "Renovación de ITIN",
      "Certificación de documentos (CAA)",
      "Atención para extranjeros sin SSN",
    ],
  },
  {
    icon: Building2,
    title: "Servicios Empresariales",
    tagline: "Formación y operación de tu negocio",
    items: [
      "Creación de LLC",
      "Corporaciones",
      "EIN (Employer ID)",
      "Bookkeeping",
      "Contabilidad",
      "Payroll (nómina)",
      "Sales Tax",
      "Consultoría empresarial",
      "Registro y mantenimiento anual",
    ],
  },
  {
    icon: FileSignature,
    title: "Formularios Migratorios",
    tagline: "Preparación y asistencia con USCIS",
    items: [
      "Preparación de formularios USCIS",
      "Asistencia en el llenado",
      "Traducción de documentos de apoyo",
      "Aviso: No somos abogados y no brindamos asesoría ni representación legal. Sin embargo, trabajamos con los mejores abogados y podemos referirte en caso de requerir asesoría personalizada.",
    ],
    notice: true,
  },
  {
    icon: Stamp,
    title: "Servicios de Notaría",
    tagline: "Notary Public certificada en Florida",
    items: [
      "Notarizaciones presenciales",
      "Notarización remota (RON)",
      "Poderes (Power of Attorney)",
      "Affidavits · Declaraciones juradas",
      "Permisos de viaje para menores",
      "Certificación de firmas",
      "Copias certificadas",
      "Traducción Certificada",
      "Tramitación de apostillas",
    ],
  },
  {
    icon: HeartHandshake,
    title: "Seguros",
    tagline: "Protección para ti y los tuyos",
    items: [
      "Seguro Médico",
      "Seguro de Vida",
      "Protección familiar",
      "Opciones para trabajadores independientes",
      "Asesoría personalizada",
    ],
  },
];

export default function Services() {
  return (
    <section id="servicios" className="py-24 lg:py-32 bg-[#f8fafc]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl reveal">
          <div className="text-xs font-semibold text-[#0B2D5C] tracking-[0.2em] uppercase mb-4">
            Nuestros servicios
          </div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0f172a] leading-[1.1]">
            Todo lo que tu vida y tu negocio necesitan,{" "}
            <span className="text-[#0B2D5C]">en un solo lugar.</span>
          </h2>
          <p className="mt-5 text-lg text-[#475569] leading-relaxed">
            Soluciones integrales para personas, familias, empresarios y pequeños negocios. Servicio profesional,
            transparente y personalizado en cada trámite.
          </p>
        </div>

        <div className="mt-16 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              className="reveal group relative bg-white border border-[#e2e8f0] p-8 rounded-sm hover:border-[#C89B2C] hover:-translate-y-1 transition-all duration-300 flex flex-col"
              style={{ transitionDelay: `${i * 40}ms` }}
              data-testid={`service-card-${i}`}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-[#0B2D5C]/8 group-hover:bg-[#0B2D5C] transition-colors mb-5">
                <s.icon
                  className="text-[#0B2D5C] group-hover:text-white transition-colors"
                  size={22}
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="font-display text-xl font-semibold text-[#0f172a] mb-1">{s.title}</h3>
              <p className="text-xs text-[#C89B2C] font-semibold tracking-wide mb-4 uppercase">{s.tagline}</p>

              <ul className="space-y-2 flex-1">
                {s.items.slice(0, s.notice ? s.items.length - 1 : s.items.length).map((it, j) => (
                  <li key={j} className="flex items-start gap-2 text-[14px] text-[#334155]">
                    <Check className="text-[#0B2D5C] flex-shrink-0 mt-0.5" size={14} strokeWidth={2.5} />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>

              {s.notice && (
                <div className="mt-4 pt-4 border-t border-[#e2e8f0] text-[11px] text-[#475569] italic leading-relaxed">
                  {s.items[s.items.length - 1]}
                </div>
              )}

              <ArrowUpRight
                className="absolute top-8 right-8 text-[#e2e8f0] group-hover:text-[#C89B2C] transition-colors"
                size={20}
                strokeWidth={1.5}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
